import { useEffect, useState } from 'react';
import { GET, PUT } from '../../utils/apicalls';
import { API } from '../../config/api';
import { App, Button, Card, Col, Form, Input, InputNumber, Row, Select, Space, Upload } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { UploadOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import AWS from 'aws-sdk';

function UpdateCourse() {
    const [isLoading, setIsLoading] = useState(false);
    const [courseData, setCourseData] = useState(null);

    const [awsData, setawsData] = useState<any>({});
    const [form] = Form.useForm();
    const [allCategoryData, setAllCategoryData] = useState([]);
    const { notification } = App.useApp();
    const { id } = useParams();
    const navigate = useNavigate();

    const fetchawsDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
            if (response && response.accessKeyId) {
                setawsData(response); // Not response.data
            } else if (response?.data?.accessKeyId) {
                setawsData(response.data); // If using Axios-style
            } else {
                console.warn("AWS credentials not found in response", response);
            }
        } catch (error) {
            console.error("Failed to fetch AWS credentials", error);
        } finally {
            setIsLoading(false);
        }
    };


    // State for file URLs
    const [fileUrls, setFileUrls] = useState({
        course_image: null,
        course_certificate_image: null,
        course_Brousher: null,
        course_logo1: null,
        course_logo2: null,
        course_logo3: null,
        course_logo4: null
    });
    useEffect(() => {
        if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
            AWS.config.update({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region,
            });
        }
    }, [awsData]);
    useEffect(() => {
        fetchawsDetails();
    }, []);

    const S3_BUCKET = awsData?.bucketName;
    const handleFileUpload = (file: any, folder: string, fieldName: string) => {
        return new Promise((resolve, reject) => {
            const timestamp = Date.now();
            const fileName = file.name.replace(/\s+/g, "-");
            const key = `${folder}/${timestamp}_${fileName}`;

            const s3 = new AWS.S3({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region
            });

            const params = {
                Bucket: S3_BUCKET, // Use from response instead of hardcoded
                Key: key,
                Body: file,
                ContentType: file.type,
            };

            s3.upload(params, (err: any, data: any) => {
                if (err) {
                    console.error("S3 Upload Error:", err);
                    notification.error({
                        message: `${fieldName} upload failed!`,
                        description: `Error: ${err.message || "Unknown error"}`,
                    });
                    reject(err);
                } else {
                    const fileUrl = data.Location;

                    const newFileUrls: any = { ...fileUrls };
                    newFileUrls[fieldName] = fileUrl;
                    setFileUrls(newFileUrls);

                    form.setFieldValue(fieldName, fileUrl);
                    notification.success({ message: `${fieldName} uploaded successfully!` });
                    resolve({ ...data, Location: fileUrl });
                }
            });
        });
    };



    // Create upload props for each file type
    const createUploadProps = (folder: any, fieldName: any, accept = "image/*") => {
        return {
            name: "file",
            accept,

            multiple: false,
            showUploadList: false,
            customRequest: async (options: any) => {
                const { onSuccess, onError, file } = options;
                try {
                    setIsLoading(true);
                    const data = await handleFileUpload(file, folder, fieldName);
                    onSuccess(data);
                } catch (error) {
                    onError(error);
                } finally {
                    setIsLoading(false);
                }
            },
            onChange: (info: any) => {
                if (info.file.status === "done") {
                    notification.success({ message: `${fieldName} upload successful!` });
                } else if (info.file.status === "error") {
                    notification.error({ message: `${fieldName} upload failed!` });
                }
            },
        };
    };

    const uploadProps = {
        course_image: createUploadProps("images", "course_image"),
        course_certificate_image: createUploadProps("certificates", "course_certificate_image", ".pdf,.jpg,.jpeg,.png"),
        course_Brousher: createUploadProps("brochures", "course_Brousher", ".pdf,.jpg,.jpeg,.png"),
        course_logo1: createUploadProps("logos", "course_logo1"),
        course_logo2: createUploadProps("logos", "course_logo2"),
        course_logo3: createUploadProps("logos", "course_logo3"),
        course_logo4: createUploadProps("logos", "course_logo4"),
    };

    const fetchCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});

            if (!response?.data) {
                notification.error({ message: "Failed to fetch course data" });
                return;
            }

            const data = response.data;
            setCourseData(data);

            // Update file URLs state
            setFileUrls({
                course_image: data?.course_image || null,
                course_certificate_image: data?.course_certificate_image || null,
                course_Brousher: data?.course_Brousher || null,
                course_logo1: data?.course_logo1 || null,
                course_logo2: data?.course_logo2 || null,
                course_logo3: data?.course_logo3 || null,
                course_logo4: data?.course_logo4 || null,
            });

            // Set form values
            form.setFieldsValue({
                course_title: data?.course_title || '',
                subcourse_title: data?.subcourse_title || '',
                course_price: data?.course_price || 0,
                category_id: Number(data?.category_id) || undefined,
                course_certificate_image: data?.course_certificate_image || '',
                course_Brousher: data?.course_Brousher || '',
                course_logo1: data?.course_logo1 || '',
                course_logo2: data?.course_logo2 || '',
                course_logo3: data?.course_logo3 || '',
                course_logo4: data?.course_logo4 || '',
                course_image: data?.course_image || '',
                course_duration: data?.course_duration || '',
                course_description: data?.course_description?.map((desc: any) => ({ description: desc })) || [],
                targetAudiance: data?.targetAudiance?.map((aud: any) => ({ audience: aud })) || [],
            });

        } catch (error) {
            console.error('Error fetching course:', error);
            notification.error({
                message: "Failed to fetch course data",
                description: (error as Error).message || "Unknown error"
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAllCategory = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CATEGORIES, {});

            if (response?.data) {
                setAllCategoryData(response.data);
            } else {
                notification.warning({ message: "No categories found" });
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            notification.error({ message: "Failed to fetch categories" });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCourse();
        fetchAllCategory();

    }, [id]); // Add id as dependency

    // Helper function to display file preview
    const renderFilePreview = (url: any, type: any) => {
        if (!url) return null;

        if (url.toLowerCase().endsWith(".pdf")) {
            return (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block mt-2 text-blue-600 underline"
                >
                    View Uploaded PDF
                </a>
            );
        } else {
            return (
                <img
                    src={url}
                    alt={type}
                    style={{ width: "50px", height: "50px", marginTop: "8px" }}
                />
            );
        }
    };

    const submitHandler = async (values: any) => {
        try {
            setIsLoading(true);

            // Convert array of objects to array of strings
            const course_description = values.course_description?.map((item: { description: any; }) => item.description) || [];
            const targetAudiance = values.targetAudiance?.map((item: { audience: any; }) => item.audience) || [];

            const updatedCourse = {
                course_title: values.course_title,
                subcourse_title: values.subcourse_title,
                course_price: Number(values.course_price),
                category_id: Number(values.category_id),
                course_certificate_image: values.course_certificate_image,
                course_image: values.course_image,
                course_duration: values.course_duration,
                course_description,
                targetAudiance,
                course_Brousher: values.course_Brousher,
                course_logo1: values.course_logo1,
                course_logo2: values.course_logo2,
                course_logo3: values.course_logo3,
                course_logo4: values.course_logo4,
            };

            const response = await PUT(`${API.UPDATE_COURSE}${id}`, updatedCourse);

            if (response) {
                notification.success({ message: "Course updated successfully!" });
                navigate(-1);
            } else {
                notification.error({ message: "Failed to update course" });
            }
        } catch (error) {
            console.error('Error updating course:', error);
            notification.error({
                message: "Failed to update course",
                description: (error as Error).message || "Please try again later"
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-7xl mx-auto py-6 px-4">
            <h1 className="text-2xl font-bold mb-6 text-center">Update Course</h1>

            <Card className="shadow-md rounded-lg">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={submitHandler}
                    className="space-y-4"
                >
                    <Row gutter={16}>
                        {/* Course Title */}
                        <Col xs={24} md={8}>
                            <Form.Item
                                label="Course Title"
                                name="course_title"
                                rules={[{ required: true, message: 'Please input the course title!' }]}
                            >
                                <Input placeholder="Enter course title" />
                            </Form.Item>
                        </Col>

                        {/* Course Sub Title */}
                        <Col xs={24} md={8}>
                            <Form.Item
                                label="Course Sub Title"
                                name="subcourse_title"
                                rules={[{ required: true, message: 'Please input the course Sub title!' }]}
                            >
                                <Input placeholder="Enter course Sub title" />
                            </Form.Item>
                        </Col>

                        {/* Course Price */}
                        <Col xs={24} md={8}>
                            <Form.Item
                                label="Course Price"
                                name="course_price"
                            // rules={[{ required: true, message: 'Please input the course price!' }]}
                            >
                                <InputNumber
                                    placeholder="Enter course price"
                                    min={0}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>

                        {/* Category */}
                        <Col xs={24} md={8}>
                            <Form.Item
                                label="Category"
                                name="category_id"
                                rules={[{ required: true, message: 'Please select a category!' }]}
                            >
                                <Select
                                    placeholder="Select a category"
                                    loading={isLoading}
                                    notFoundContent="No categories found"
                                >
                                    {allCategoryData.map((category: any) => (
                                        <Select.Option key={category.id} value={category.id}>
                                            {category.categoryTitle}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* Course Duration */}
                        <Col xs={24} md={8}>
                            <Form.Item
                                label="Course Duration"
                                name="course_duration"
                                rules={[{ required: true, message: 'Please input the course duration!' }]}
                            >
                                <Input placeholder="Enter course duration (e.g., 6 weeks)" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        {/* Course Image */}
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Course Image"
                                name="course_image"
                                rules={[{ required: true, message: "Please upload the course image!" }]}
                            >
                                <div className="flex items-center space-x-4">
                                    <Upload {...uploadProps.course_image}>
                                        <Button icon={<UploadOutlined />}>Upload Course Image</Button>
                                    </Upload>
                                    {renderFilePreview(fileUrls.course_image, "Course")}
                                </div>
                            </Form.Item>
                        </Col>

                        {/* Certificate */}
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Course Certificate (PDF or Image)"
                                name="course_certificate_image"
                            >
                                <div className="flex items-center space-x-4">
                                    <Upload {...uploadProps.course_certificate_image}>
                                        <Button icon={<UploadOutlined />}>Upload Certificate</Button>
                                    </Upload>
                                    {renderFilePreview(fileUrls.course_certificate_image, "Certificate")}
                                </div>
                            </Form.Item>
                        </Col>

                        {/* Brochure */}
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Course Brochure (PDF or Image)"
                                name="course_Brousher"
                            >
                                <div className="flex items-center space-x-4">
                                    <Upload {...uploadProps.course_Brousher}>
                                        <Button icon={<UploadOutlined />}>Upload Brochure</Button>
                                    </Upload>
                                    {renderFilePreview(fileUrls.course_Brousher, "Brochure")}
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* Logos */}
                    <Card title="Partner Logos" className="mb-4">
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="Logo 1" name="course_logo1">
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_logo1}>
                                            <Button icon={<UploadOutlined />}>Upload</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_logo1, "Logo 1")}
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="Logo 2" name="course_logo2">
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_logo2}>
                                            <Button icon={<UploadOutlined />}>Upload</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_logo2, "Logo 2")}
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="Logo 3" name="course_logo3">
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_logo3}>
                                            <Button icon={<UploadOutlined />}>Upload</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_logo3, "Logo 3")}
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="Logo 4" name="course_logo4">
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_logo4}>
                                            <Button icon={<UploadOutlined />}>Upload</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_logo4, "Logo 4")}
                                    </div>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    <Row gutter={16}>
                        {/* Course Description (Array) */}
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Course Description"
                                name="course_description"
                                rules={[{ required: true, message: 'Please input at least one description!' }]}
                            >
                                <Form.List
                                    name="course_description"
                                    rules={[
                                        {
                                            validator: async (_, names) => {
                                                if (!names || names.length < 1) {
                                                    return Promise.reject(new Error('At least one description is required'));
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (
                                                <Space key={key} className="flex items-center mb-2" align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'description']}
                                                        rules={[{ required: true, message: 'Required' }]}
                                                        className="mb-0 flex-grow"
                                                    >
                                                        <Input placeholder="Enter description" />
                                                    </Form.Item>
                                                    <Button
                                                        onClick={() => remove(name)}
                                                        icon={<MinusOutlined />}
                                                        danger
                                                    />
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button
                                                    type="dashed"
                                                    onClick={() => add()}
                                                    block
                                                    icon={<PlusOutlined />}
                                                >
                                                    Add Description
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </Col>

                        {/* Target Audience (Array) */}
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Target Audience"
                                name="targetAudiance"
                            // rules={[{ required: true, message: 'Please input at least one target audience!' }]}
                            >
                                <Form.List
                                    name="targetAudiance"
                                // rules={[
                                //     {
                                //         validator: async (_, names) => {
                                //             if (!names || names.length < 1) {
                                //                 return Promise.reject(new Error('At least one target audience is required'));
                                //             }
                                //         },
                                //     },
                                // ]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (
                                                <Space key={key} className="flex items-center mb-2" align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'audience']}
                                                        // rules={[{ required: true, message: 'Required' }]}
                                                        className="mb-0 flex-grow"
                                                    >
                                                        <Input placeholder="Enter target audience" />
                                                    </Form.Item>
                                                    <Button
                                                        onClick={() => remove(name)}
                                                        icon={<MinusOutlined />}
                                                        danger
                                                    />
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button
                                                    type="dashed"
                                                    onClick={() => add()}
                                                    block
                                                    icon={<PlusOutlined />}
                                                >
                                                    Add Target Audience
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item className="flex justify-end mt-6">
                        <Space>
                            <Button onClick={() => navigate(-1)}>
                                Cancel
                            </Button>
                            <Button type="primary" htmlType="submit" loading={isLoading}>
                                {isLoading ? 'Updating...' : 'Update Course'}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}

export default UpdateCourse;